import Div from '@jumbo/shared/Div';
import PreviewIcon from "@mui/icons-material/Preview";
import { LoadingButton } from '@mui/lab';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { displayDateFun } from 'app/utils/constants/functions';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import UploadCatalogue from './uploadCatalogueModal';
import UploadImagesModal from './uploadImagesModal';
import { uploadImage } from 'app/services/apis/UploadImagesApi';
import axios from 'app/services/config';
import Swal from 'sweetalert2';

const MeasurementForm = () => {
    let { state } = useLocation();
    state = state?.menuItemData;
    console.log(state)
    const navigate = useNavigate();
    const itemMeasurement = state?.order_measurement?.find((ele) => ele?.item_master_item_name === state?.order_sub_item_name) || {}
    const [openCatalogueImage, setOpenCatalogueImage] = useState(false)
    const [openUploadImage, setOpenUploadImage] = useState(false);

    const handleSubmit = async function (values) {
        try {
            const config = {
                withCredentials: true,
                headers: {
                    withCredentials: true,
                },
            };
            const res = await axios.post(
                `${process.env.REACT_APP_URL}/api/order/update-order_item_measurement?order_items_id=${state?.order_items_id}`,
                values,
                config
            );
            if (res?.status === 201) {
                Swal.fire("Success", res?.data?.message, "success");
                navigate('/dashboard/order/admin')
            }
        } catch (error) {
            Swal.fire("Error", error?.response?.data?.message, "error");
        }
    }

    const formik = useFormik({
        initialValues: {
            measurement: { ...itemMeasurement },
            order_item_catalogue_image: state?.order_item_catalogue_image || [],
            order_item_image: state?.order_item_image || [],
            remark: state?.order_item_remarks
        },
        onSubmit: function (values) {
            handleSubmit(values)
        }
    });

    const removeImages = function(){
        formik.setFieldValue("order_item_image",[])
    }

    const handleImage = async (e) => {
        const files = e.target.files; // This is a FileList object
        if (files.length === 0) {
            // No new files selected, do nothing
            return;
        }
        const imageData = new FormData();
        for (let j = 0; j < files.length; j++) {
            imageData.append("image", files[j]);
        }
        try {
            const imageUrlRes = await uploadImage(imageData);
            formik.setFieldValue('order_item_image', [...imageUrlRes])
        } catch (error) {
            console.error("Error uploading image:", error);
        } finally {
        }
        e.target.value = ""
    };
    return (
        <Div sx={{ mt: -4 }}>
            <Typography variant='h1'>Edit Item Measurement</Typography>
            <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Order No.
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Order Type
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Gender
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    maxWidth: "140px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Port Number & Name
                            </TableCell>

                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    maxWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Order Date
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "80px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Exp. Delivery Date
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>{state?.order_no}</TableCell>
                            <TableCell>{state?.order_type}</TableCell>
                            <TableCell>{state?.order_gender}</TableCell>
                            <TableCell>{state?.order_port_no_and_name}</TableCell>
                            <TableCell>{displayDateFun(state?.order_date)}</TableCell>
                            <TableCell>
                                {displayDateFun(state?.order_est_delivery_date)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Div
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    alignItems: "center",
                    rowGap: 2
                }}
            >
                <Box sx={{ display: "flex", rowGap: 2, columnGap: 7, alignItems: "center", flexWrap: "wrap" }}>
                    <Div sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" sx={{ fontWeight: "600", mr: 1, mb: 0 }}>
                            Item No:-
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 0 }}>{state?.order_item_no}</Typography>
                    </Div>
                    <Div sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" sx={{ fontWeight: "600", mr: 1, mb: 0 }}>
                            Fabric:-
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 0 }}>
                            {state?.order_item_kc_fabric_code}
                        </Typography>
                    </Div>

                    <Div sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" sx={{ fontWeight: "600", mr: 1, mb: 0 }}>
                            Item:-
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 0 }}>{state?.order_item_name}</Typography>
                    </Div>

                    <Div sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" sx={{ fontWeight: "600", mr: 1, mb: 0 }}>
                            SubItem:-
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 0 }}>
                            {state?.order_sub_item_name ? state?.order_sub_item_name : "-"}
                        </Typography>
                    </Div>
                    <Div sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h5" sx={{ fontWeight: "600", mr: 1, mb: 0 }}>
                            Client Name:-
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 0 }}>{state?.order_client_name}</Typography>
                    </Div>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", }} >
                    <Div>
                        {formik?.values?.order_item_catalogue_image != null ? (
                            <Typography>{`Images Selected: ${formik?.values?.order_item_catalogue_image?.length}`}</Typography>
                        ) : (
                            <Typography>Images Selected: 0</Typography>
                        )}
                        <label
                            htmlFor={`catalogueImageInput`} // Matching label with the unique ID
                            style={{
                                display: "block",
                                textAlign: "left",
                                marginTop: "10px",
                                width: "151px",
                            }}
                        >
                            <Button
                                component="span"
                                size="small"
                                variant="contained"
                                sx={{ fontSize: "10px" }}
                                onClick={() => {
                                    setOpenCatalogueImage(true);
                                }}
                            >
                                Upload Image
                            </Button>
                        </label>
                    </Div>


                    <Div
                        sx={{
                            display: "flex",
                            alignItems: "end",
                        }}
                    >
                        <Div sx={{ minWidth: "120px" }}>
                            {formik?.values?.order_item_image != null ? (
                                <Typography>{`Images Selected: ${formik?.values?.order_item_image?.length}`}</Typography>
                            ) : (
                                <Typography>{`Images Selected:0`}</Typography>
                            )}
                            <input
                                type="file"
                                multiple
                                accept=".jpg, .jpeg, .png"
                                id={`imageInput`} // Unique ID for regular image input
                                style={{ display: "none" }}
                                onChange={(e) => handleImage(e)}
                            />
                            <label
                                htmlFor={`imageInput`} // Matching label with the unique ID
                                style={{
                                    display: "block",
                                    textAlign: "left",
                                    marginTop: "10px",
                                    width: "151px",
                                }}
                            >
                                <LoadingButton
                                    // loading={loader}
                                    component="span"
                                    size="small"
                                    variant="contained"
                                    sx={{ fontSize: "10px" }}
                                >
                                    Upload Image
                                </LoadingButton>
                            </label>
                        </Div>
                        <PreviewIcon
                            color="primary"
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                setOpenUploadImage(true);
                            }}
                        />
                    </Div>
                </Box>

            </Div>
            {formik?.values?.measurement && Object.keys(formik?.values?.measurement)?.length > 0 && <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Name
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                Actual Measurement
                            </TableCell>
                            <TableCell
                                sx={{
                                    textAlign: "left",
                                    minWidth: "100px",
                                    verticalAlign: "middle",
                                    color: "white",
                                }}
                            >
                                New Measurement
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {formik?.values?.measurement && Object.entries(formik?.values?.measurement?.item_master_measurement || {})?.map(([Key], index) => {
                            return (
                                <TableRow>
                                    <TableCell>{Key}</TableCell>
                                    <TableCell>{itemMeasurement?.item_master_measurement?.[Key]}</TableCell>
                                    <TableCell>
                                        <TextField
                                            size='small'
                                            name={`measurement.item_master_measurement.${Key}`}
                                            value={formik?.values?.measurement?.item_master_measurement?.[Key]}
                                            onChange={formik?.handleChange}
                                            onBlur={formik?.handleBlur}
                                        />
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>}
            <Div>
                <Typography variant='h3' sx={{ my: 2 }}>Remark</Typography>
                <TextField
                    size='small'
                    name='remark'
                    sx={{
                        width: "100%"
                    }}
                    value={formik?.values?.remark}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                />
            </Div>
            <Div sx={{ textAlign: "center", mt: 5 }}>
                <Button variant='contained' onClick={formik?.handleSubmit}>Submit</Button>
            </Div>
            {openCatalogueImage && <UploadCatalogue
                open={openCatalogueImage}
                formik={formik}
                onClose={setOpenCatalogueImage}
            />}
            {openUploadImage && <UploadImagesModal
                open={openUploadImage}
                onClose={() => setOpenUploadImage(false)}
                rowData={formik?.values?.order_item_image}
                removeImages={removeImages}
            />}
        </Div>
    )
}

export default MeasurementForm